import React from 'react';
import '../../styles/Team.css';
import '../../styles/Fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import anitaPhoto from '../../assets/management/Anita.jpg';
import carissaPhoto from '../../assets/management/Carissa.jpg';
import edwinPhoto from '../../assets/management/Edwin.JPG';
import josePhoto from '../../assets/management/Jose.jpg';
import alexyssPhoto from '../../assets/management/MAAM ALEX.jpg';
import marinelPhoto from '../../assets/management/MARINEL.png';
import shaynePhoto from '../../assets/management/SHAYNE.jpg';
import emmanuelPhoto from '../../assets/management/emmanuel.jpg';
import ContactForm from '../contactUs/ContactUs';

// To add a photo: import it above and set `photo: importedImage` on that member.
const teamMembers = [
  {
    name: 'Edwin D. Rodriguez',
    title: 'President & CEO',
    photo: edwinPhoto,
    photoFit: 'contain',
    email: 'mailto:edwin.rodriguez@rcsphil.com',
  },
  {
    name: 'Emmanuel R. Ibasco',
    title: 'Vice President Executive & COO',
    photo: emmanuelPhoto,
    email: 'mailto:emmanuel.ibasco@rcsphil.com',
  },
  {
    name: 'Jose Adrian Jiovanni E. Brinas',
    title: 'Vice President & General Manager',
    photo: josePhoto,
    email: 'mailto:jb.brinas@rcsphil.com',
  },
  {
    name: 'Alexyss G. Rodriguez',
    title: 'Vice President for Operations',
    photo: alexyssPhoto,
    email: 'mailto:alexyss.rodriguez@rcsphil.com',
  },
  {
    name: 'Anita T. Obogne',
    title: 'Accounting Manager',
    photo: anitaPhoto,
    email: 'mailto:acctg@rcsphil.com',
  },
  {
    name: 'Carissa Faye A. Santiago, LCB',
    title: 'Brokerage Team Leader',
    photo: carissaPhoto,
    email: 'mailto:brokerage.mnl@rcsphil.com',
  },
  {
    name: 'Marinel D. Capanayan',
    title: 'Business Development Team Leader',
    photo: marinelPhoto,
    email: 'mailto:cs.mnl@rcsphil.com',
  },
  {
    name: 'Shayne S. Difuz',
    title: 'HEAD OF IT & SYSTEMS',
    photo: shaynePhoto,
    email: 'mailto:it@rcsphil.com',
  },
];

const TeamMemberCard = ({ member, leadershipCard = false }) => (
  <div className={`team-card ${leadershipCard ? 'leadership-card' : ''} h-100`}>
    <div className="team-avatar-wrapper">
      {member.photo ? (
        <img
          src={member.photo}
          alt={member.name}
          className={member.photoFit ? `photo-fit-${member.photoFit}` : ''}
        />
      ) : (
        <i className="fas fa-user team-avatar-icon"></i>
      )}
    </div>
    <h4 className="team-member-name mb-0">{member.name}</h4>
    <p className="team-member-title">{member.title}</p>
    {member.email && (
      <div className="team-member-contact">
        <a
          className="team-member-email"
          href={member.email}
          aria-label={`Email ${member.name} at ${member.email.replace('mailto:', '')}`}
        >
          {member.email.replace('mailto:', '')}
        </a>
        <div className="team-member-socials">
          <a href={member.email} aria-label={`Email ${member.name}`}>
            <i className="fas fa-envelope"></i>
          </a>
        </div>
      </div>
    )}
  </div>
);

const TeamSec = () => {
  return (
    <>
      <section id="team" className="team-section">
        <div className="container">
          {/* Team layout: 2 cards on the first row, followed by 3 and 3. */}
          <div className="team-members-grid">
            {teamMembers.map((member, index) => (
              <div
                className={`team-member-grid-item ${index < 2 ? 'team-member-grid-item-leadership' : ''}`}
                key={member.name}
              >
                <TeamMemberCard member={member} leadershipCard={index < 2} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <ContactForm />

      {/* CTA */}
      <section className="team-cta-section py-5">
        <div className="container text-center py-4">
          <h2 className="team-cta-title mb-3">Want to Work With Our Team?</h2>
          <p className="team-cta-text mb-4">
            Reach out and let our management team help design the right logistics solution
            for your business.
          </p>
          <a href="/contactUs" className="team-cta-button">
            Contact Us
          </a>
        </div>
      </section>
    </>
  );
};

export default TeamSec;
